export const FIDO_VERIFY_TYPE = {
  PIN: '16384',
  BIO: '2', // FINGER 지문
  FACE_ID: '2',
  // bionic: '4096',  // ASIS 홍채인식
};

export const FIN_CERT_SIMPLE_KEY_TYPE = {
  FINGER: '1',
  // EYE: '2',
  FACE_ID: '3',
};

/**
 * 단말기 상태바 컬러
 */
export const STATUS_BAR_COLOR = {
  light: {
    'main-page-wrap': {
      default: '0',
      scrolled: '0',
    },
    'sub-main-page': {
      default: '1',
      scrolled: '0',
    },
    'default-page': {
      default: '0',
      scrolled: '0',
    },
    'comfy-banking-page': {
      default: '0',
      scrolled: '0',
    },
    round: {
      default: '1',
      scrolled: '0',
    },
    white: {
      default: '0',
      scrolled: '0',
    },
    bg: {
      default: '0',
      scrolled: '0',
    },

    login: {
      default: '0',
      scrolled: '0',
    },
  },
  dark: {
    'main-page-wrap': {
      default: '0',
      scrolled: '0',
    },
    'sub-main-page': {
      default: '1',
      scrolled: '0',
    },
    'default-page': {
      default: '0',
      scrolled: '0',
    },
    'comfy-banking-page': {
      default: '1',
      scrolled: '1',
    },
    round: {
      default: '1',
      scrolled: '1',
    },
    white: {
      default: '1',
      scrolled: '1',
    },
    bg: {
      default: '1',
      scrolled: '1',
    },

    login: {
      default: '0',
      scrolled: '0',
    },
  },
};
